import { CardActions, CardContent, Collapse, Divider} from "@mui/material";
import { PropsWithChildren } from "react";
import StepMenuLandingCardDetailsButton from "./StepMenuLandingCardDetailsButton";

export type StepMenuLandingCardDetailsProps = {
    expanded: boolean;
    onToggleExpanded: () => void;
    hideCollapseButton?: boolean
};

export default function StepMenuLandingCardDetails({
    children,
    expanded,
    onToggleExpanded,
    hideCollapseButton
}: PropsWithChildren<StepMenuLandingCardDetailsProps>) {



    return (
        <>


            <Collapse in={expanded} timeout="auto">
                <CardContent sx={{
                    padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`
                }}>
                    {children}
                </CardContent>
            </Collapse>

            {!hideCollapseButton && 
            <>
                <Divider />

                <CardActions disableSpacing>
                    <StepMenuLandingCardDetailsButton
                        onClick={onToggleExpanded}
                        expanded={expanded}
                    />
                </CardActions>
            </>
            }
        </>
    );
}
